import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ColorPickerComponent, ColorPickerDirective } from 'ngx-color-picker';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { TarjetaComponent } from 'src/app/components/tarjeta/tarjeta.component';
import { PerfilService } from 'src/app/services/perfil.service';
import ClassicEditor from 'src/ckeditor5/build/ckeditor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-profiles',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CdkScrollable,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    TablerIconsModule,
    NgxSpinnerModule,
    MatPaginator,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    TarjetaComponent,
    ColorPickerComponent,
    ColorPickerDirective,
    CKEditorModule,
    MatSlideToggleModule,
  ],
  templateUrl: './admin-profiles.component.html',
  styleUrl: './admin-profiles.component.scss'
})
export class AdminProfilesComponent implements OnInit {

  isBrowser = false;

  color: string;
  colorLetras: string = '#FFFFFF';
  colorFondo: string = '#FFFFFF';
  public toggle: boolean = false;
  public toggleLetra: boolean = false;
  public toggleFondo: boolean = false;
  public Editor = ClassicEditor;
  profile: any;
  isEditMode = false;
  idCliente: string | null = '';
  imgBannerFile?: File;
  imgLogoFile?: File;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private perfilService: PerfilService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
     this.isBrowser = isPlatformBrowser(platformId);
  }

  async  ngOnInit() {
    if (this.isBrowser) {
      const m = await import('src/ckeditor5/build/ckeditor');
      this.Editor = (m as any).default ?? (m as any).ClassicEditor ?? m;
    }

    if (!this.isBrowser) return;

    this.route.paramMap.subscribe(params => {
      const perfilId = params.get('id');
      this.idCliente  = params.get('icliente');
      this.isEditMode = !!perfilId && perfilId != "0";

      if (this.isEditMode) {
        this.cargarPerfil(perfilId!);
      } else {
        this.inicializarPerfil();
      }
    });

  }



  private cargarPerfil(perfilId: string): void {
    this.spinner.show();
    this.perfilService.getPerfilByID(perfilId).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.profile = data;
        this.profile.backgroundColor = this.profile.backgroundColor || '#FFFFFF';
        this.color = this.profile.buttonColor;
        this.colorLetras = this.profile.letterColor;
        this.colorFondo = this.profile.backgroundColor;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar los datos del Perfil:', err);
        this.inicializarPerfil(); // Si hay error, usa valores por defecto
      },
    });
  }

  private inicializarPerfil(): void {
    this.profile = {
      idCliente: Number(this.idCliente),
      imgBanner: environment.apiEndpoint + "images/banner1.jpg",
      buttonColor: this.color,
      letterColor: this.colorLetras,
      backgroundColor: this.colorFondo,
      showAddress: true,
      showDivisor: true,
      showButtonComponent: true,
      showRSComponent: true,
      showVideo: false,
      showQR: true,
      showFooter: false,
      showLogo: false,
      buttons: [
        { title: 'Descubre más', link: 'https://ejemplo.com', type: 'full' },
        { title: 'Sitio Web', link: 'https://pagina.com', type: 'outline' }
      ],
      redes: [
      ],
      video: '',
      nombre: '',
      imgLogo: environment.apiEndpoint + "images/logo.png",
      logoHeight: 50,
      bannerHeight:170,
      showTexto: false,
      showWSPForm: false,
      texto : '',
      textoForm : 'Empresa',
      showButtonCall: true,
      showButtonWSP: true,
      showButtonMail: true,
      showFooterTienda: false,
      showSave: true,
      textoButtonForm: 'Enviame tus Datos'
    };
  }


  onFileChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (!file.type.startsWith('image/')) {
        alert('Por favor, selecciona un archivo de imagen válido.');
        input.value = ''; // Limpiar el campo de archivo
        return;
      }
      if (controlName === 'img') {
        this.imgBannerFile = file;
      } else if (controlName === 'imgLogo') {
        this.imgLogoFile = file;
      }

      const reader = new FileReader();
      reader.onload = () => {
        if (controlName === 'img') {
          this.profile.imgBanner = reader.result;
        } else if (controlName === 'imgLogo') {
          this.profile.imgLogo = reader.result;
        }

      };
      reader.readAsDataURL(file);

    }
  }

  updateProfile() {
    this.profile.redes = this.profile.redes.map(red => ({
      ...red,
      iconClass: this.getSocialIconClass(red.tipo)
    }));
    this.profile = { ...this.profile };
  }

  addButton() {
    this.profile.buttons.push({ title: '', link: '', type: 'full' });
  }

  removeButton(index: number) {
    this.profile.buttons.splice(index, 1);
  }

  colorChanged(newColor: string) {
    this.profile = { ...this.profile, buttonColor: newColor };
  }

  colorLetrasChanged(newColor: string) {
    this.profile = { ...this.profile, letterColor: newColor };
  }

  colorFondoChanged(newColor: string) {
    this.profile = { ...this.profile, backgroundColor: newColor };
  }

  toggleChangedShowAddress(newValue: boolean) {
    this.profile = { ...this.profile, showAddress: newValue };
  }

  toggleChangedDivisor(newValue: boolean) {
    this.profile = { ...this.profile, showDivisor: newValue };
  }

  toggleChangedButtonComponent(newValue: boolean) {
    this.profile = { ...this.profile, showButtonComponent: newValue };
  }

  toggleChangedRSComponent(newValue: boolean) {
    this.profile = { ...this.profile, showRSComponent: newValue };
  }

  toggleChangedShowVideo(newValue: boolean) {
    this.profile = { ...this.profile, showVideo: newValue };
  }

  toggleChangedShowQR(newValue: boolean) {
    this.profile = { ...this.profile, showQR: newValue };
  }

  toggleChangedShowFooter(newValue: boolean) {
    this.profile = { ...this.profile, showFooter: newValue };
  }

  toggleChangedShowLogo(newValue: boolean) {
    this.profile = { ...this.profile, showLogo: newValue };
  }

  toggleChangedShowTexto(newValue: boolean) {
    this.profile = { ...this.profile, showTexto: newValue };
  }

  toggleChangedShowWSPForm(newValue: boolean) {
    this.profile = { ...this.profile, showWSPForm: newValue };
  }

  toggleChangedShowButtonCall(newValue: boolean) {
    this.profile = { ...this.profile, showButtonCall: newValue };
  }

  toggleChangedShowButtonWSP(newValue: boolean) {
    this.profile = { ...this.profile, showButtonWSP: newValue };
  }

  toggleChangedShowButtonMail(newValue: boolean) {
    this.profile = { ...this.profile, showButtonMail: newValue };
  }

  toggleChangedShowFooterTienda(newValue: boolean) {
    this.profile = { ...this.profile, showFooterTienda: newValue };
  }

  toggleChangedShowSave(newValue: boolean) {
    this.profile = { ...this.profile, showSave: newValue };
  }

  addRedSocial() {
    if (!this.profile.redes) {
      this.profile.redes = [];
    }
    this.profile.redes.push({ tipo: 'facebook', link: '' });
    this.updateProfile();
  }

  removeRedSocial(index: number) {
    this.profile.redes.splice(index, 1);
    this.updateProfile();
  }

  volver(): void {
    this.router.navigate(['/admin-client', this.idCliente]);
  }



  getSocialIconClass(tipo: string): string {
    const iconMap: { [key: string]: string } = {
      facebook: 'fab fa-facebook-f',
      instagram: 'fab fa-instagram',
      twitter: 'fa-brands fa-x-twitter',
      linkedin: 'fab fa-linkedin-in',
      youtube: 'fab fa-youtube',
      tiktok: 'fab fa-brands fa-tiktok',
      promo: 'fas fa-bullhorn'
    };
    return iconMap[tipo] || 'fas fa-link'; // ícono por defecto
  }


  updateTexto(value: string) {
    this.profile = { ...this.profile, texto: value };
  }

  guardarPerfil() {
    this.profile.backgroundColor = this.profile.backgroundColor || '#FFFFFF';

    const perfilEditado = new FormData();
    perfilEditado.append('perfil', JSON.stringify(this.profile));
    if (this.imgBannerFile) {
      perfilEditado.append('imgBanner', this.imgBannerFile);
    }
    if (this.imgLogoFile) {
      perfilEditado.append('imgLogo', this.imgLogoFile);
    }

    if (this.isEditMode) {
      //update
      this.spinner.show();
      this.perfilService.updatePerfil(perfilEditado).subscribe({
        next: (data) => {
          this.spinner.hide();
          this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          this.volver();
        },
        error: (err) => {
          console.error('Error al editar el perfil:', err);
          this.spinner.hide();
          this.snackBar.open('Error al editar el perfil.', 'Cerrar', { duration: 3000 });
        },
      });
    } else {
      //insert
      this.spinner.show();
      this.perfilService.createPerfil(perfilEditado).subscribe({
        next: (data) => {
          this.spinner.hide();
          this.snackBar.open(data.msg, 'Cerrar', { duration: 3000 });
          this.volver();
        },
        error: (err) => {
          console.error('Error al crear el perfil:', err);
          this.spinner.hide();
          this.snackBar.open('Error al crear el perfil.', 'Cerrar', { duration: 3000 });
        },
      });
    }

  }

}
